import { Injectable } from '@angular/core';
import { RequestType } from '../../enums/request-type.enum';

@Injectable({
    providedIn: 'root'
})
export class RequestTrackingService {
    paymentRequestIds: number[] = [];
    ExpectFundIds: number[] = [];
    transferFundIds: number[] = [];
    journalRequestIds: number[] = [];

    updateList(requestType: string, uniqueId: number, isLocked: boolean): void {
        let targetList: number[] | undefined;

        switch (requestType) {
            case RequestType.Payment:
                targetList = this.paymentRequestIds;
                break;
            case RequestType.ExpectFunds:
                targetList = this.ExpectFundIds;
                break;
            case RequestType.TransferFund:
                targetList = this.transferFundIds;
                break;
            case RequestType.Journal:
                targetList = this.journalRequestIds;
                break;
            default:
                console.error('Invalid request type:', requestType);
                return;
        }

        if (isLocked) {
            if (!targetList.includes(uniqueId)) {
                targetList.push(uniqueId);
            }
        } else {
            const index = targetList.indexOf(uniqueId);
            if (index > -1) {
                targetList.splice(index, 1);
            }
        }
    }
}
